var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"csTab",class:"csTab",style:(("background-color: " + _vm.tabBackGround)),on:{"click":_vm.selectTab}},[_c('p',{class:((_vm.disabled ? 'csTab-disabled' : '') + " " + (_vm.active ? 'csTab-active' : '')),style:(("color: " + (_vm.active ? _vm.titleActiveColor : _vm.titleInactiveColor)))},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-296fbec4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/src/tab.vue
// module id = 234
// module chunks = 0 15